<template>
  <v-app class="disable-favorites">
    <ul v-if="menu" class="manage_groups_menu">
      <li v-for="item in menu" :key="item.name">
        <p class="menu_item" @click="item.opened = !item.opened">
          <v-icon v-if="item.opened"> mdi-chevron-down </v-icon>
          <v-icon v-else> mdi-chevron-right </v-icon>
          {{ item.name }}
        </p>
        <ul class="submenu" v-if="item.opened && item.items">
          <li v-for="subitem in item.items" :key="subitem.name">
            <p class="menu_item">
              <a :href="subitem.link" v-if="subitem.link">
                <v-icon :icon="subitem.img" class="subitem_image" size="small"></v-icon>
                {{ subitem.name }}
              </a>
            <p class="menu_item" @click="subitem.opened = !subitem.opened" v-if="subitem.items">
              <v-icon v-if="subitem.opened"> mdi-chevron-down </v-icon>
              <v-icon v-else> mdi-chevron-right </v-icon>
              {{ subitem.name }}
            </p>
            <ul class="submenu" v-if="subitem.opened && subitem.items">
              <li v-for="subitem2 in subitem.items" :key="subitem2.name">
                <p class="menu_item">
                  <a :href="subitem2.link" v-if="subitem2.link">
                    <v-icon :icon="subitem2.img" class="subitem_image" size="small"></v-icon>
                    {{ subitem2.name }}
                  </a>

                </p>
              </li>
            </ul>
            </p>
          </li>
        </ul>
      </li>
    </ul>
  </v-app>
</template>

<script>
export default {
  name: "manage_groups",
  data() {
    return {
      menu: null,
    };
  },
  created() {
    let filtered = this.$model.filter((element) => {
      if (typeof element.opened == 'undefined') {
        element.opened = false;
      }
      element.items = element.items.filter((item) => {
        if (item.items) {
          item.opened = false;
        }
        return item.access !== false;
      });
      return element.access !== false;
    });
    this.menu = filtered;
  },
  methods: {
  },
};
</script>
<style lang="scss">
#procollege_block_navigation {
  .v-application__wrap {
    min-height: auto;
  }

  .v-layout--full-height {
    height: auto;
  }

  .manage_groups_menu {
    margin: 0;
    padding: 0;
    cursor: pointer;
    list-style: none;

    .submenu {
      padding-left: 15px;
      list-style: none;

      .subitem_image {
        margin-bottom: 2px;
      }
    }
  }

  .menu_item {
    margin: 3px 0;
    padding: 0 0 0 5px;
    color: #030eb4;

    a:hover {
      color: #02026E;
      text-decoration: none;
    }
  }

  .v-application {
    background-color: inherit;
  }
}
</style>
